import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import styles from "./abortGame.module.css";
import PopupWithImage from "../popupWithImage/popupWithImage";

const AbortGame = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [popupShow, setPopupShow] = useState(false);

  useEffect(() => {
    if (popupShow) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [popupShow]);

  return (
    <>
      <div className={styles.settings}>
        <div className={styles.settingsOpen} onClick={() => setPopupShow(true)}>
          {t("setup.abort_game")}
        </div>
      </div>

      {popupShow &&
        <PopupWithImage
          name={t("pop_up_notifications.abort_name")}
          description={t("pop_up_notifications.abort_description")}
          button={t("pop_up_notifications.button_terminate")}
          button_exit={t("pop_up_notifications.button_cancel")}
          type={"confirmation"}
          defExit={() => setPopupShow(false)}
          defContinue={() => navigate("/")}
        />
      }

    </>
  );
};
export default AbortGame;

